import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DISPATCH_FAILURE_SERVICE_URL } from 'src/app/injection-tokens';
import { Observable } from 'rxjs';
import { DispatchFailure } from './dispatch-failure';

@Injectable({
  providedIn: 'root',
})
export class DispatchFailuresService {
  constructor(
    @Inject(DISPATCH_FAILURE_SERVICE_URL) readonly serviceURL: string,
    readonly http: HttpClient
  ) {}

  getDispatchFailures(): Observable<DispatchFailure[]> {
    return this.http.get<DispatchFailure[]>(this.serviceURL);
  }
}
